import { Link } from "gatsby";
import PropTypes from "prop-types";
import React from "react";
import { HeaderH1, Tagline } from "./../styledcomponents/headerstyles";

const Header = ({ siteTitle }) => (
  <header>
    <div>
      <HeaderH1>
        <Link to="/">{siteTitle}</Link>
      </HeaderH1>
      <Tagline>A Novel about Supermarkets and Democracy by Eric Giroux</Tagline>
    </div>
  </header>
);

Header.propTypes = {
  siteTitle: PropTypes.string,
};

Header.defaultProps = {
  siteTitle: ``,
};

export default Header;
